import { render } from "./AppInputV2.vue?vue&type=template&id=45364555"
import script from "./AppInputV2.vue?vue&type=script&lang=js"
export * from "./AppInputV2.vue?vue&type=script&lang=js"

import "./AppInputV2.vue?vue&type=style&index=0&id=45364555&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__